import React from "react";
import { EjercicioByRange } from "../../CreditoyCobranza/ReporteCobranza/Helper/EjercicioByRange";
import { PeriodoSelect } from "../../CreditoyCobranza/ReporteCobranza/Helper/PeriodoSelect";

// Capa 2: dibuja un campo del filtro según su "tipo".
// Tipos: select | fecha | ejercicio | periodo | texto | custom
// Fecha de creación: 2026-09-15 — Autor: IA (Claude)
export const normalizarOpciones = (opciones = []) =>
  opciones.map((op) => (typeof op === "object" && op !== null ? op : { value: op, label: String(op) }));

const CampoFiltro = ({ campo, valor, valores, onCambiar }) => {
  const { name, label, tipo = "select", opciones, opcionTodos, maxLength = 100, min, max, render } = campo;
  const valorSeguro = valor ?? "";
  const resolver = (prop) => (typeof prop === "function" ? prop(valores) : prop);
  const onChange = (e) => onCambiar(name, e.target.value);

  let control;
  switch (tipo) {
    case "select":
      control = (
        <select name={name} value={valorSeguro} onChange={onChange}>
          {opcionTodos && <option value="">{opcionTodos}</option>}
          {normalizarOpciones(resolver(opciones) || []).map((op) => (
            <option key={op.value} value={op.value}>{op.label}</option>
          ))}
        </select>
      );
      break;
    case "fecha":
      control = (
        <input
          type="date"
          name={name}
          value={valorSeguro}
          min={resolver(min) || undefined}
          max={resolver(max) || undefined}
          onChange={onChange}
        />
      );
      break;
    case "ejercicio":
      control = <EjercicioByRange name={name} value={valorSeguro} onChange={(e) => onCambiar(name, Number(e.target.value))} />;
      break;
    case "periodo":
      control = <PeriodoSelect name={name} value={valorSeguro} onChange={(e) => onCambiar(name, Number(e.target.value))} />;
      break;
    case "texto":
      control = <input type="text" name={name} value={valorSeguro} maxLength={maxLength} onChange={onChange} />;
      break;
    case "custom":
      control = render ? render({ valor, valores, cambiar: (v) => onCambiar(name, v) }) : null;
      break;
    default:
      control = null;
  }

  return (
    <label className="filtro-campo">
      <span className="filtro-campo-label">{label}</span>
      {control}
    </label>
  );
};

export default CampoFiltro;
